import { Box, SxProps, Chip, Typography } from '@mui/material';
import React from 'react';
import { headingFontBold, vars } from '../../../Theme';
import AppTooltip from '../AppTooltip/AppTooltip';
import { flexBase } from '../../../Constants';

/** Styles for Typography. */
const fontSx: SxProps = {
    ...headingFontBold,
    fontSize: 14,
};

/** Styles for Box. */
const boxSx: SxProps = {
    ...flexBase,
    width: '100%',
    height: '100%',
};

/** Ellipsis styles. */
const ellipsisSx: SxProps = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};

/**
 * Decorative component that is mainly used for ensuring a consistent display of textual data within a sidepanel.
 */
export default ({
    text,
    sx,
    docVariant,
    subject,
    showHoverButtons,
    typographyFontFamily,
}: IMainFieldProps) => (
    <AppTooltip title={text ?? ''} placement={'top-start'}>
        <Box sx={{ ...boxSx, ...sx }}>
            {docVariant ? (
                <>
                    <Chip
                        label={docVariant}
                        sx={{
                            ...headingFontBold,
                            backgroundColor: vars.brandDarkBlue,
                            color: vars.white,
                            fontSize: 12,
                        }}
                        size='small'
                        variant='filled'
                    />
                    <Typography
                        sx={{
                            ...fontSx,
                            ...ellipsisSx,
                            ...typographyFontFamily,
                            marginLeft: '4px',
                            display: showHoverButtons ? 'none' : 'block',
                        }}
                    >
                        {subject}
                    </Typography>
                </>
            ) : (
                <Typography
                    sx={{
                        ...fontSx,
                        ...ellipsisSx,
                        ...typographyFontFamily,
                    }}
                >
                    {text}
                </Typography>
            )}
        </Box>
    </AppTooltip>
);

/**
 * Interface that describes the props for a MainField component.
 */
export interface IMainFieldProps {
    /** Text to be displayed. */
    text: string;

    /** (Optional) Extra styles to be applied to the component. */
    sx?: SxProps;

    /** (Optional) Document's DocVariant. */
    docVariant?: string;

    /** (Optional) Document's Subject. */
    subject?: string;

    /** (Optional) Flag that controls the "showHoverButtons" check. */
    showHoverButtons?: boolean;

    /** (Optional) Font family for the typography component. */
    typographyFontFamily?;
}
